<script>
    import { description_attributes, equipment_attribute } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/product_tab_attributes.js?1733898724672';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724672';
    import Attribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Attribute.svelte?1733898724672';

    export let product;

    function hasAttribute(attributes) {
        for (const attribute of attributes) {
            let value = product[attribute];

            if (value !== undefined) {
                return true
            }
        }
        return false;
    }
</script>

{#if product}
    {#if product.short_description}
        <h2>{@html get_attribute_value(product, 'short_description')}</h2>
    {/if}
    <div data-ax-uid={get_attribute_value(product, 'sku')} data-ax-content="default">
        {#if product.description}
            {@html get_attribute_value(product, 'description')}
        {/if}
    </div>
    {#each description_attributes as attribute}
        <Attribute {product} {attribute} />
    {/each}
    {#if hasAttribute(equipment_attribute)}
        <h2>{window.__('product.equipment')}</h2>
        <Attribute {product} attribute={equipment_attribute} />
    {/if}
{/if}
